import type { GetOversightResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOversightResultByIdArgs = { id: string };

export const useGetOversightResultById = createQueryHook<
  UseGetOversightResultByIdArgs,
  GetOversightResultByIdResponseRow[],
  GetOversightResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.oversightResultById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ oversight_result_parent: data }),
  graphqlDocument: GetOversightResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
